import { LEAVE_CONTENT_EDITOR_LABEL } from "./workspaceLabels";
import { WorkspaceLeaveControl } from "./WorkspaceLeaveControl";

type LearningPathBackControlProps = {
  onBack: () => void;
};

export function LearningPathBackControl({ onBack }: LearningPathBackControlProps) {
  return (
    <WorkspaceLeaveControl label={LEAVE_CONTENT_EDITOR_LABEL} onBack={onBack} />
  );
}
